import React, { useEffect } from 'react';
import { connectRefinementList } from 'react-instantsearch-dom';
import { RefinementListProvided } from 'react-instantsearch-core';
import { isEqual } from 'lodash';
import DoubleLabeledGenericToggleSwitch from '../DoubleLabeledGenericToggleSwitch';
import { AdminSingleBreedToggleStateInterface } from '../../admin-dashboard-tables/interfaces';

interface Props extends RefinementListProvided {
  adminSingleBreedToggleState: AdminSingleBreedToggleStateInterface,
  updateAdminSingleBreedToggleState: (newToggledFieldState: AdminSingleBreedToggleStateInterface)
    => void,
}

const PurebredHybridConnectedToggleContainer: React.FC<Props> = ({
  adminSingleBreedToggleState,
  updateAdminSingleBreedToggleState,
  refine,
  currentRefinement,
}) => {
  useEffect(() => {
    const {
      searchPurebredsOn,
      searchHybridsOn,
    } = adminSingleBreedToggleState;

    if (
      searchPurebredsOn
      && !searchHybridsOn
      && !isEqual(currentRefinement, ['true'])
    ) {
      refine(['true']);
    }

    if (
      searchHybridsOn
      && !searchPurebredsOn
      && !isEqual(currentRefinement, ['false'])
    ) {
      refine(['false']);
    }

    if (
      searchPurebredsOn
      && searchHybridsOn
      && !isEqual(currentRefinement, [''])
    ) {
      refine(['']);
    }
  }, [adminSingleBreedToggleState, currentRefinement]);

  return (
    <div className="purebred-hybrid-connected-toggle-container">
      <DoubleLabeledGenericToggleSwitch
        labelLeft="Purebred / Designer"
        labelLeftClass="toggle toggle-left d-flex align-items-center px-3 py-2 mb-0"
        containerClass="purebred-hybrid-toggle purebred-container"
        id="admin_single_breed_purebred"
        checked={!!adminSingleBreedToggleState.searchPurebredsOn}
        setChecked={(checked) => {
          updateAdminSingleBreedToggleState({
            searchPurebredsOn: checked,
          });
        }}
        toggleTextOn="on"
        toggleTextOff="off"
      />
      <DoubleLabeledGenericToggleSwitch
        labelLeft="Hybrid / Mixed Breed"
        labelLeftClass="toggle toggle-right d-flex align-items-center px-3 py-2 mb-0"
        containerClass="purebred-hybrid-toggle hybrid-container"
        toggleSliderClass="toggle-slider-right"
        id="admin_single_breed_hybrid"
        checked={!!adminSingleBreedToggleState.searchHybridsOn}
        setChecked={(checked) => {
          updateAdminSingleBreedToggleState({
            searchHybridsOn: checked,
          });
        }}
        toggleTextOn="on"
        toggleTextOff="off"
      />
    </div>
  );
};

export default connectRefinementList(PurebredHybridConnectedToggleContainer);
